// @flow

import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import { APP_NAME } from '../util/config';

import { PRIVACY_POLICY_ROUTE } from '../util/web-routes';

const Footer = () => (
  <div
    style={{
      width: '100%',
      padding: '10px',
    }}
  >
    <hr />
    <footer>
      <Typography variant="caption">
        © {APP_NAME} {(new Date()).getFullYear()} |
        <Link to={PRIVACY_POLICY_ROUTE} style={{ color: 'gray' }}>  Privacy Policy</Link>
      </Typography>
    </footer>
  </div>
);

export default Footer;
